// extracted by mini-css-extract-plugin
export default {"l":"d8a783079b"};